import { useEffect, useState } from "react";

let overlayCount = 0;

export default function OverlayContainer({ children, show = false }) {
  const [stackIndex, setStackIndex] = useState(0);

  useEffect(() => {
    if (show) {
      setStackIndex(++overlayCount);
      return () => {
        overlayCount = Math.max(0, overlayCount - 1);
      };
    }
  }, [show]);

  const zIndex = 600 + stackIndex * 10;

  return <div style={{ zIndex }}>{children}</div>;
}
